import { ConsumptionWidget } from './revenueShared';

export const MonthlyIncome = () => <ConsumptionWidget period="MONTH" titleKey="consumptionMonthTitle" />;
